import * as React from "react";
import { useEffect, useState } from "react";
import { IAddress, ICSIDUserStatus } from "../../../store/csid/types";
import { toggleFullScreenLoader } from "../../../util/common";
import { DialogComponent } from "../../common/DialogComponent";
import FullSSNComponent from "../../csid/FullSSNComponent";
import FullSINComponent from "../../csid/FullSINComponent";
import L3CallInComponent from "../L3/L3CallInComponent";
import L3ContinueComponent from "../L3/L3ContinueComponent";
import L3DisclosureComponent from "../L3/L3DisclosureComponent";
import L3SecurityQuestionComponent from "../L3/L3SecurityQuestionComponent";
import L3OTPOptionComponent from "../L3/L3OTPOptionComponent";
import L3OTPVerificationComponent from "../L3/L3OTPVerificationComponent";
import L3SuccessComponent from "../L3/L3SuccessComponent";
import L3SystemErrorComponent from "../L3/L3SystemErrorComponent";
import L3InvalidSsnComponent from "../L3/L3InvalidSsnComponent";
import L3NotEnoughInfoComponent from "../L3/L3NotEnoughInfoComponent";
import * as services from "../../../store/service";
import { useTranslation } from "react-i18next";
import * as CSIDActions from "../../../store/csid/actions";
import * as MyAccountActions from "../../../store/myAccount/actions";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

interface IProps {
    initCSIDUserStatus: ICSIDUserStatus;
    creditAuthCallback: any;
    displayFlowAsDialog?: boolean;
}

interface IL3QuestionOption {
    "question-id": string;
    "option-id": string;
}

interface IL3Option {
    "option-id": string;
    "option-text": string;
}

interface IL3Question {
    "question-id": string;
    "question-text": string;
    options: IL3Option[];
}

interface IDFL3QuestionDTO {
    "auth-status": string;
    "status-code": string;
    message: string;
    questions: IL3Question[];
}

const IDFCreditAuthentication: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const maxTUOTPRetryAllowed = 3;
    const parentPrimaryPhone = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userInfo ? (state.loggedInUser.userInfo.phoneNumber ? state.loggedInUser.userInfo.phoneNumber : "") : "") : ""
    );

    const status = {
        success: "success",
        error: "error",
        systemError: "system-error",
        locked: "locked",
        inProgress: "in-progress",
        invalidSsn: "invalid-ssn",
        noQuestion: "no-question",
        l3LastTryTimemout: "l3-timeout-locked",
        l3OtpLocked: "l3-otp-locked",
        lockedNotEnoughInfo: "locked-not-enough-info",
        overTUOTPRequest: "over-tu-otp-request",
    };

    const dispatch = useDispatch();
    const getAccountInformation = () => dispatch(MyAccountActions.actionCreators.getAccountInformation(true));

    const [showCallInComponent, setShowCallInComponent] = useState(false);
    const [showInitialL3Continue, setShowInitialL3Continue] = useState(false);
    const [showDisclosureDialog, setShowDisclosureDiaglog] = useState(false);
    const [disclosureAgreed, setDisclosureAgreed] = useState(false);
    const [showFullSSNDialog, setShowFullSSNDialog] = useState(false);
    const [showL3SecurityQuestionDialog, setShowL3SecurityQuestionDialog] = useState(false);
    const [showL3VerifiedDialog, setShowL3VerifiedDialog] = useState(false);
    const [showL3ContinueDialogForError, setShowL3ContinueDialogForError] = useState(false);
    const [l3SecurityQuestionTryCount, setL3SecurityQuestionTryCount] = useState(0);
    const [showL3SystemError, setShowL3SystemError] = useState(false);
    const [showL3InvalidSsnComponent, setShowL3InvalidSsnComponent] = useState(false);
    const [showL3NotEnoughInfoComponent, setShowL3NotEnoughInfoComponent] = useState(false);

    const [callInReason, setCallInReason] = useState("locked");
    const [invalidSsnAttemptStatus, setInvalidSsnAttemptStatus] = useState("");
    const [noQuestionAttemptStatus, setNoQuestionAttemptStatus] = useState("");
    const [messageKeyForL3ContinueWithError, setMessageKeyForL3ContinueWithError] = useState("credit-service");
    const [ssn, setSSN] = useState("0");
    const [dob, setDOB] = useState("");
    const [address, setAddress] = useState<IAddress>({
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
    });

    const initialQuestionOption: IL3QuestionOption = {
        "question-id": "",
        "option-id": "",
    };
    const [blackBoxID, setBlackBoxID]=useState("");
    const [isDobRequired, setIsDobRequired] = useState(false);
    const [isAddressRequired, setIsAddressRequired] = useState(false);
    const [isTuCanadianUser, setIsTuCanadianUser] = useState(false);
    const userCountry = useSelector((state: ApplicationState) =>
        state.myAccountServiceState?._unifiedAccountInfo?.country
    );

    const isCanadianUser = isTuCanadianUser || userCountry?.toUpperCase() === 'CA';
    const [isAutoEnrolledUserUser, setIsAutoEnrolledUserUser] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showL3OTPOptionDialog, setShowL3OTPOptionDialog] = useState(false);
    const [showL3OTPVerificationDialog, setShowL3OTPVerificationDialog] = useState(false);
    const [tuTrustedSessionId, settuTrustedSessionId]:any = useState("");
    let [tuSessionIdStore, setTuSessionIdStore]:any= useState([]);
    const [questionOption, setQuestionOption] = useState(initialQuestionOption);
    const [selectedOTPOptionText, setSelectedOTPOptionText] = useState("");
    const [loadedSecurityQuestionResponse, setLoadedSecurityQuestionResponse] = useState(null);
    const personalAccountInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._personalAccountInformation
                : null
            : null
    );

    // default values for props
    let blnDisplayFlowAsDialog = false;
    if (props.displayFlowAsDialog != null) {
        blnDisplayFlowAsDialog = props.displayFlowAsDialog;
    }

    const getPrimatyPhoneNumber = () => {
        let phoneNumber = personalAccountInformation && personalAccountInformation.primaryPhone ? personalAccountInformation.primaryPhone : parentPrimaryPhone;
        return phoneNumber;
    };

    const globalTryCount = useSelector((state: ApplicationState) => {
        if (state.csidUserStatusState) {
            return state.csidUserStatusState?.globalQuestionTryCount;
        }
    });

    const setGlobalTryCount = (tryCount: number) => dispatch(CSIDActions.actionCreators.setGlobalQuestionTryCount(tryCount));

    useEffect(() => {
        setL3SecurityQuestionTryCount(globalTryCount != null ? globalTryCount : 1);

        if (
            props.initCSIDUserStatus["auth-status"] != null &&
            (props.initCSIDUserStatus["auth-status"].trim().toUpperCase() === "LOCKED" ||
                props.initCSIDUserStatus["auth-status"].trim().toUpperCase() === "LOCKED-NOT-ENOUGH-INFO"||
                props.initCSIDUserStatus["auth-status"].trim().toUpperCase() === "L3-OTP-LOCKED"||
                props.initCSIDUserStatus["auth-status"].trim().toUpperCase() === "L3-TIMEOUT-LOCKED")
        ) {
            setShowInitialL3Continue(false);

            if (props.initCSIDUserStatus["auth-status"].trim().toUpperCase() === "LOCKED-NOT-ENOUGH-INFO") {
                setCallInReason("locked-not-enough-info");
           }
            // show call in component
            setShowCallInComponent(true);
            if (props.initCSIDUserStatus["auth-status"].trim().toUpperCase() === "L3-OTP-LOCKED")        {
               setCallInReason("l3-otp-locked");
           }
          setShowCallInComponent(true);
     } else {
            const dobStatus = props.initCSIDUserStatus["dob-status"];
            setIsDobRequired(dobStatus === "REQUIRED");

            const addressStatus = props.initCSIDUserStatus["address-status"];
            setIsAddressRequired(addressStatus === "REQUIRED");

            setShowInitialL3Continue(true);
        }
        // for tu canadian user
        if (props.initCSIDUserStatus.isTUUser) {
                services.isTuCanadianUser().then((response) => {
                    if (response && response.hasError === false) {
                        setIsTuCanadianUser(response.isCanadiaUser);
                    }
                });
            services.IsAutoEnrolledUser().then((response) => {
                if (response) {
                    setIsAutoEnrolledUserUser(response.isAutoEnrolledUser);
                }
            });
        }
    }, [props.initCSIDUserStatus]);

    useEffect(() => {
        if (isLoading) {
            toggleFullScreenLoader(true);
        } else {
            toggleFullScreenLoader(false);
        }
    }, [isLoading]);
    // #region disclosure
    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowDisclosureDiaglog(false);
        // if user close the disclosure dialog without agree, then in UI load "Verify my identity" component
        setShowInitialL3Continue(true);
    };

    const disclosureSubmitCallBack = (callbackObj: any) => {
        // close the disclosure dialog.
        setShowDisclosureDiaglog(false);
        // set the agree flag true for future use.
        setDisclosureAgreed(true);
        if (
            props.initCSIDUserStatus.l3AuthProvider.isTU &&
            props.initCSIDUserStatus["ssn-status"] === "NOT_REQUIRED" &&
            (isCanadianUser || isAutoEnrolledUserUser)
        ) {
            showL3ProcessDialog(props.initCSIDUserStatus.l3AuthProvider.isTU, ssn, dob, address);
        } else {
            setShowFullSSNDialog(true);
        }
    };
    // #endregion

    // #region initial-continue
    const initialContinueSubmitCallBack = (callbackObj: any) => {
        setShowInitialL3Continue(false);

        if (!disclosureAgreed) {
            setShowDisclosureDiaglog(true);
        } else {
            disclosureSubmitCallBack({ status: "success", data: "Agreed by user" });
        }
    };
    // #endregion

    // #region fullSSN-dialog
    const closeFullSSNDialogComponent = (callbackObj: any) => {
        setShowFullSSNDialog(false);
        // if user close the Full SSN with cancel / ESC / X, then in UI load "Verify my identity" component
        setShowInitialL3Continue(true);
    };

    const submitFullSSNDialogComponent = (callbackObj: any) => {
        //setShowFullSSNDialog(false);
        if (callbackObj.status === status.success) {
            setSSN(callbackObj.data.ssn);
            setDOB(callbackObj.data.dob);
            setAddress(callbackObj.data.address as IAddress);
            showL3ProcessDialog(props.initCSIDUserStatus.isTUUser, callbackObj.data.ssn, callbackObj.data.dob, callbackObj.data.address,callbackObj.data.blackBoxKey);
            setBlackBoxID(callbackObj.data.blackBoxKey);
       }
    };

    const showL3ProcessDialog = (isTUUser: boolean, ssn: string, dob: string, address: any, blackBoxKey?:string) => {
        if (isTUUser && !isCanadianUser) {
            setIsLoading(true);
            services
                .getTUOtpGenerationKey()
                .then((data) => {
                    //call config and loader_only.js
                    setIsLoading(false);
                    const tuOTPPublicKey = data.tuOTPGenerationKey;
                    const useOTPFlow = data.useOTPFlow;
                    const clientIP= data.ipAddress;
                    const sessionType = "0";

                    if (useOTPFlow) {
                        services.getBlackBoxSessionID(blackBoxKey, clientIP, sessionType)
                        .then((data) =>{
                         tuOTPPublicKey;
                         clientIP;
                         let sessionId = data.sessionId;

                      //you should store this sessionId for retrieval at a later point
                                setTuSessionIdStore([...tuSessionIdStore,sessionId]);
                                sessionId = tuSessionIdStore[0]==null ?  sessionId : tuSessionIdStore[0];
                                settuTrustedSessionId(sessionId);
                                getL3SecurityQuestions(sessionId, ssn, dob, address);
                            }
                        )
                        .catch(function(error)
                        {
                        console.log(error);
                        })
                    } else {
                        setShowFullSSNDialog(false);
                        setShowL3SecurityQuestionDialog(true);
                    }
                  })
         .catch(function (error) {
                    setIsLoading(false);
                    console.log(error);
                });
        } else {
            setShowFullSSNDialog(false);
            setShowL3SecurityQuestionDialog(true);
        }


    };
    const getL3SecurityQuestions = (tuTrustedSessionId: string, ssn: string, dob: string, address: any) => {
        setIsLoading(true);
        const phoneNumber = getPrimatyPhoneNumber();
        services
            .getL3SecurityQuestion(ssn, false, dob, address, phoneNumber, tuTrustedSessionId)
            .then((data) => {
                setIsLoading(false);
                setShowFullSSNDialog(false);
                var responseObj;
                try {
                    responseObj = JSON.parse(data);
                } catch (e) {
                    responseObj = data;
                }

                if (responseObj.providerResponse != null) {
                    var question = responseObj.providerResponse as IDFL3QuestionDTO;
                    setLoadedSecurityQuestionResponse(responseObj);
                    if (question.questions != null) {
                        if (question.questions.length === 1) {
                            setShowL3OTPOptionDialog(true);
                        } else {
                            setShowL3SecurityQuestionDialog(true);
                        }
                    } else {
                        if (responseObj.providerResponse["is-wrong-ssn"]) {
                            setInvalidSsnAttemptStatus(responseObj.providerResponse["auth-status"]);
                            setShowL3InvalidSsnComponent(true);
                        } else if (responseObj.providerResponse["auth-status"] && responseObj.providerResponse["auth-status"] === status.locked) {
                            setShowCallInComponent(true);
                        } else if (responseObj.providerResponse["auth-status"] && responseObj.providerResponse["auth-status"] === status.l3OtpLocked) {
                            setShowCallInComponent(true);
                        }
                        else if (responseObj.providerResponse["auth-status"] && responseObj.providerResponse["auth-status"] === status.lockedNotEnoughInfo) {
                            setNoQuestionAttemptStatus(responseObj.providerResponse["auth-status"]);
                            setShowL3NotEnoughInfoComponent(true);
                        } else {
                            setShowL3SystemError(true);
                        }
                    }
                } else {
                    setShowL3SystemError(true);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setShowFullSSNDialog(false);
                setShowL3SystemError(true);
            });
    };
    // #endregion

    //#region start OTP capture section
    const closeL3OTPOptionDialogComponent = (callbackObj: any) => {
        setShowL3OTPOptionDialog(false);
        // if user close the L3 Security Question Dialog with cancel / ESC / X, then in UI load "Verify my identity" component
        setShowInitialL3Continue(true);
    };
    const submitL3OTPOptionDialogComponent = (callbackObj: any) => {
        setShowL3OTPOptionDialog(false);

        if (callbackObj.status === "success") {
            setQuestionOption(callbackObj.questionOption);
            setSelectedOTPOptionText(callbackObj.selectedOptionText);
            setShowL3OTPVerificationDialog(true);
        }
    };

    const getL3OTPOptionErrorCallBack = (callbackObj: any) => {
        setShowL3OTPOptionDialog(false);
        if (callbackObj.status === status.invalidSsn) {
            setInvalidSsnAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3InvalidSsnComponent(true);
        } else if (callbackObj.status === status.noQuestion || callbackObj.status === status.lockedNotEnoughInfo) {
            setNoQuestionAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3NotEnoughInfoComponent(true);
        } else if (callbackObj.status === status.locked) {
            setShowCallInComponent(true);
        } else if (callbackObj.status ===status.l3OtpLocked) {
            setShowCallInComponent(true);
        } else {
            setShowL3SystemError(true);
        }
    };

    const closeL3OTPVerificationComponent = (callbackObj: any) => {
        setShowL3OTPVerificationDialog(false);
        setShowInitialL3Continue(true);
    };
    const submitL3OTPVerificationComponent = (callbackObj: any) => {

        if (callbackObj) {
            setShowL3OTPVerificationDialog(false);

            if (callbackObj.status === status.success) {
                // l3 authentication success
                setShowL3VerifiedDialog(true);
            } else if (callbackObj.status === status.locked) {
                setShowCallInComponent(true);
            } else if (callbackObj.status === status.error) {
                setShowL3SystemError(true);
            } else if (callbackObj.status === status.l3OtpLocked) {
                setCallInReason(callbackObj.status)
                setShowCallInComponent(true);

            } else if (callbackObj.status === status.inProgress) {
                setShowInitialL3Continue(true);
            }
        }
    };

    const getL3OTPVerificationErrorCallBack = (callbackObj: any) => {
        setShowL3OTPVerificationDialog(false);
        if (callbackObj.status === status.invalidSsn) {
            setInvalidSsnAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3InvalidSsnComponent(true);
        } else if (callbackObj.status === status.noQuestion || callbackObj.status === status.lockedNotEnoughInfo) {
            setNoQuestionAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3NotEnoughInfoComponent(true);
        } else if (callbackObj.status === status.locked) {
            setShowCallInComponent(true);
        } else if (callbackObj.status === status.l3OtpLocked) {
            setShowCallInComponent(true);
        }
        else {
            setShowL3SystemError(true);
        }
    };
    // #endregion

    // #region l3-security-question
    const closeL3SecurityQuestionDialogComponent = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        setL3SecurityQuestionTryCount(globalTryCount != null ? globalTryCount : 1);

        if (globalTryCount && globalTryCount > 2) {
            setShowCallInComponent(true);
        } else {
            // if user close the L3 Security Question Dialog with cancel / ESC / X, then in UI load "Verify my identity" component
            setShowInitialL3Continue(true);
        }
    };

    const submitL3SecurityQuestionDialogComponent = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        if (callbackObj.status === status.success) {
            // l3 authentication success
            setShowL3VerifiedDialog(true);

            if (address && address.address1) {
                getAccountInformation();
            }
        } else if (callbackObj.status === status.locked) {
            setShowCallInComponent(true);
        }
        else if (callbackObj.status === status.l3OtpLocked) {
            setShowCallInComponent(true);
        }
        else if (callbackObj.status === status.error) {
            let errorReason = callbackObj.data.reason;

            setMessageKeyForL3ContinueWithError(errorReason);
            setShowL3SystemError(true);
        } else if (callbackObj.status === status.inProgress) {
            setShowInitialL3Continue(true);
        }
    };

    const getL3QuestionErrorCallBack = (callbackObj: any) => {
        // close the dialog and show manual authentication to be on safe side
        setShowL3SecurityQuestionDialog(false);
        if (callbackObj.status === status.invalidSsn) {
            setInvalidSsnAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3InvalidSsnComponent(true);
        } else if (callbackObj.status === status.noQuestion || callbackObj.status === status.lockedNotEnoughInfo) {
            setNoQuestionAttemptStatus(callbackObj.data.detail.providerResponse["auth-status"]);
            setShowL3NotEnoughInfoComponent(true);
        } else if (callbackObj.status === status.locked) {
            setShowCallInComponent(true);
        } else if (callbackObj.status === status.l3OtpLocked) {
            setShowCallInComponent(true);
        } else {
            setShowL3SystemError(true);
        }
    };
    // #endregion

    const l3SecurityQuestionDialogTimeOut = (callbackObj: any) => {
        setShowL3SecurityQuestionDialog(false);
        let errorReason = callbackObj.data.reason;
        if (errorReason === status.l3LastTryTimemout) {

            setCallInReason(errorReason);
            setShowCallInComponent(true);
        } else {
            setMessageKeyForL3ContinueWithError(errorReason);
            setShowL3ContinueDialogForError(true);
        }
    };

    const l3ContinueWithErrorSubmitCallBack = (callbackObj: any) => {
        setShowL3ContinueDialogForError(false);
        const tempTryCount = l3SecurityQuestionTryCount + 1;
        setL3SecurityQuestionTryCount(tempTryCount);
        setGlobalTryCount(tempTryCount);

        showL3ProcessDialog(props.initCSIDUserStatus.l3AuthProvider.isTU, ssn, dob, address, callbackObj.BlackBoxKey);
    };

    // #region l3-success
    const l3SuccessComponentContinueCallBack = (callbackObj: any) => {
        if (props.creditAuthCallback != null) {
            props.creditAuthCallback({ stauts: status.success, data: { detail: "l3-successful" } });
        }
    };
    // #endregion

    const l3CallInCloseCallBack = (callbackObj: any) => {
        if (props.creditAuthCallback != null) {
            props.creditAuthCallback({ stauts: status.error });
        }
    };

    // #region system-error
    const l3SystemErrorCloseCallBack = (callbackObj: any) => {
        setShowL3SystemError(false);
        setShowInitialL3Continue(true);
    };
    // #endregion

    const l3InvalidSsnCloseCallBack = (callbackObj: any) => {
        setShowL3InvalidSsnComponent(false);
        if ("locked" === invalidSsnAttemptStatus) {
            setShowCallInComponent(true);
        } else {
            setShowInitialL3Continue(true);
        }
    };

    const l3InvalidSsnRetryCallBack = () => {
        setShowL3InvalidSsnComponent(false);
        setShowFullSSNDialog(true);
    };

    const l3NotEnoughInfoCloseCallBack = (callbackObj: any) => {
        setShowL3NotEnoughInfoComponent(false);
        if ("locked-not-enough-info" === noQuestionAttemptStatus) {
            setCallInReason("locked-not-enough-info");
            setShowCallInComponent(true);
        } else {
            setShowInitialL3Continue(true);
        }
    };

    const l3NotEnoughInfoRetryCallBack = () => {
        setShowL3NotEnoughInfoComponent(false);
        setShowFullSSNDialog(true);
    };

    // #region call-in
    const callInContinueCallBack = () => {
        setShowCallInComponent(false);
        window.location.reload();
    };
    // #endregion

    const l3SystemErrorRefreshCallBack = (callbackObj: any) => {
        setShowL3SystemError(false);
        setShowCallInComponent(true);
    };

    const l3SystemErrorReloadCallBack = (callbackObj: any) => {
        setShowL3SystemError(false);
        window.location.reload();
    };

    return (
        <div className={`${isLoading && "loading"}`}>
            {
                // #region continue-flow-as-page
                !blnDisplayFlowAsDialog && (
                    <React.Fragment>
                        {showCallInComponent && (
                            <L3CallInComponent
                                closeButtonText={"Close"}
                                onCloseCallback={l3CallInCloseCallBack}
                                openAsDialog={false}
                                continueButtonText={tLang("dashboard.creditScore.l3CallInComp.finishVerification")}
                                onContinueButtonCallback={callInContinueCallBack}
                                callInReason={callInReason}
                                l3Provider={"TUI"}
                            ></L3CallInComponent>
                        )}

                        {showInitialL3Continue && (
                            <L3ContinueComponent
                                submitButtonText={tLang("credit.creditScore.creditScoreWidget.ssnAuthError.creditService.authButton")}
                                onSubmitCallback={initialContinueSubmitCallBack}
                                messageKey={"idf-credit-service"}
                                continueFlowWithL3={true}
                                diplayTimerMessage={false}
                            ></L3ContinueComponent>
                        )}

                        {showDisclosureDialog && (
                            <L3DisclosureComponent
                                closeButtonText={tLang("dashboard.creditScore.l3DisclosureComp.closeButton")}
                                onCloseCallback={closeDisclosureDialogCallBack}
                                openAsDialog={false}
                                submitButtonText={tLang("dashboard.creditScore.l3DisclosureComp.submitButton")}
                                onSubmitCallback={disclosureSubmitCallBack}
                                providerName={"transunion"}
                                isTuCanadianUser={isCanadianUser}
                            ></L3DisclosureComponent>
                        )}

                        {showFullSSNDialog &&
                        (isCanadianUser ?
                            <FullSINComponent
                                closeButtonText={tLang("dashboard.creditScore.fullSINComp.cancelButtonText")}
                                onCloseCallback={closeFullSSNDialogComponent}
                                openAsDialog={false}
                                submitButtonText={tLang("dashboard.creditScore.fullSINComp.submitButtonText")}
                                onSubmitCallback={submitFullSSNDialogComponent}
                                displaySSNInputNumber={false}
                                dobRequired={isDobRequired}
                                csidUserStatus={props.initCSIDUserStatus}
                                dispalyAdditionalHeaderMessage={false}
                                ignoreCSIDSubmission={true}
                            />
                        :
                            <FullSSNComponent
                                closeButtonText={"Cancel"}
                                onCloseCallback={closeFullSSNDialogComponent}
                                openAsDialog={false}
                                submitButtonText={"Submit"}
                                onSubmitCallback={submitFullSSNDialogComponent}
                                displaySSNInputNumber={false}
                                dobRequired={isDobRequired}
                                addressRequired={isAddressRequired}
                                csidUserStatus={props.initCSIDUserStatus}
                                dispalyAdditionalHeaderMessage={false}
                                ignoreCSIDSubmission={true}
                            />
                        )}

                        {showL3OTPOptionDialog && (
                            <L3OTPOptionComponent
                                closeButtonText={"Cancel"}
                                onCloseCallback={closeL3OTPOptionDialogComponent}
                                openAsDialog={true}
                                submitButtonText={"Submit"}
                                onSubmitCallback={submitL3OTPOptionDialogComponent}
                                errorCallback={getL3OTPOptionErrorCallBack}
                                telephone={getPrimatyPhoneNumber()}
                                ssn={ssn}
                                dob={dob}
                                address={address}
                                postponeActivation={false}
                                tuTrustedSessionId={tuTrustedSessionId}
                                maxTUOTPAllowed={maxTUOTPRetryAllowed}
                                loadedResponse={loadedSecurityQuestionResponse}
                            ></L3OTPOptionComponent>
                        )}
                        {showL3OTPVerificationDialog && (
                            <L3OTPVerificationComponent
                                closeButtonText={"Cancel"}
                                onCloseCallback={closeL3OTPVerificationComponent}
                                openAsDialog={false}
                                submitButtonText={"Submit"}
                                onSubmitCallback={submitL3OTPVerificationComponent}
                                errorCallback={getL3OTPVerificationErrorCallBack}
                                telephone={getPrimatyPhoneNumber()}
                                ssn={ssn}
                                dob={dob}
                                address={address}
                                postponeActivation={false}
                                tuTrustedSessionId={tuTrustedSessionId}
                                questionOption={questionOption}
                                maxTryCount={maxTUOTPRetryAllowed}
                                selectedOTPOptionText={selectedOTPOptionText}
                            ></L3OTPVerificationComponent>
                        )}
                        {showL3SecurityQuestionDialog && (
                            <L3SecurityQuestionComponent
                                closeButtonText={tLang("dashboard.creditScore.l3SecurityQuestionComp.cancelButtonText")}
                                onCloseCallback={closeL3SecurityQuestionDialogComponent}
                                openAsDialog={false}
                                submitButtonText={tLang("dashboard.creditScore.l3SecurityQuestionComp.submitButtonText")}
                                onSubmitCallback={submitL3SecurityQuestionDialogComponent}
                                errorCallback={getL3QuestionErrorCallBack}
                                ssn={ssn}
                                dob={dob}
                                address={address}
                                postponeActivation={false}
                                prepareForIDFL3={true}
                                displayTimerForTimeout={true}
                                timesInSecondBeforeTimeout={120}
                                onTimeoutCallback={l3SecurityQuestionDialogTimeOut}
                                currentTryCount={l3SecurityQuestionTryCount}
                                maxTryCount={2}
                                loadedResponse={loadedSecurityQuestionResponse}
                                tuTrustedSessionId={tuTrustedSessionId}
                            ></L3SecurityQuestionComponent>
                        )}

                        {showL3ContinueDialogForError && (
                            <L3ContinueComponent
                                submitButtonText={"Try verification again"}
                                onSubmitCallback={l3ContinueWithErrorSubmitCallBack}
                                messageKey={messageKeyForL3ContinueWithError}
                                continueFlowWithL3={true}
                            ></L3ContinueComponent>
                        )}

                        {showL3InvalidSsnComponent && (
                            <L3InvalidSsnComponent
                                closeButtonText={tLang("dashboard.creditScore.l3InvalidSSNComp.closeButtonText")}
                                onCloseButtonCallBack={l3InvalidSsnCloseCallBack}
                                retryButtonText={tLang("dashboard.creditScore.l3InvalidSSNComp.tryAgainButtonText")}
                                onRetryCallBack={l3InvalidSsnRetryCallBack}
                                invalidSsnAttemptstatus={invalidSsnAttemptStatus}
                            ></L3InvalidSsnComponent>
                        )}

                        {showL3NotEnoughInfoComponent && (
                            <L3NotEnoughInfoComponent
                                closeButtonText={tLang("dashboard.creditScore.L3NotEnoughInfoComp.closeButtonText")}
                                onCloseButtonCallBack={l3NotEnoughInfoCloseCallBack}
                                retryButtonText={tLang("dashboard.creditScore.L3NotEnoughInfoComp.tryAgainBtnText")}
                                onRetryCallBack={l3NotEnoughInfoRetryCallBack}
                                attemptStatus={noQuestionAttemptStatus}
                            ></L3NotEnoughInfoComponent>
                        )}

                        {showL3SystemError && (
                            <L3SystemErrorComponent
                                refreshButtonText={tLang("dashboard.creditScore.l3SystemErrorComp.refreshButtonText")}
                                onRefreshCallBack={l3SystemErrorReloadCallBack}
                                closeButtonText={tLang("dashboard.creditScore.l3SystemErrorComp.closeButtonText")}
                                onCloseButtonCallBack={l3SystemErrorCloseCallBack}
                            ></L3SystemErrorComponent>
                        )}

                        {showL3VerifiedDialog && (
                            <L3SuccessComponent
                                openAsDialog={false}
                                continueButtonText={tLang("dashboard.creditScore.l3SuccessComp.continueButtonText")}
                                onContinueCallback={l3SuccessComponentContinueCallBack}
                            ></L3SuccessComponent>
                        )}
                    </React.Fragment>
                )
            }

            {
                // #region continue-flow-with-dialog
                blnDisplayFlowAsDialog && (
                    <React.Fragment>
                        {showCallInComponent && (
                            <L3CallInComponent
                                closeButtonText={""}
                                onCloseCallback={null}
                                openAsDialog={true}
                                continueButtonText={tLang("dashboard.creditScore.l3CallInComp.finishVerification")}
                                onContinueButtonCallback={callInContinueCallBack}
                                callInReason={callInReason}
                                l3Provider={"TUI"}
                            ></L3CallInComponent>
                        )}

                        {showInitialL3Continue && (
                            <L3ContinueComponent
                                submitButtonText={tLang("credit.creditScore.creditScoreWidget.ssnAuthError.creditService.authButton")}
                                onSubmitCallback={initialContinueSubmitCallBack}
                                messageKey={"idf-credit-service"}
                                continueFlowWithL3={true}
                                diplayTimerMessage={false}
                            ></L3ContinueComponent>
                        )}

                        {showDisclosureDialog && (
                            <DialogComponent dialogId="dialog-l3-disclosure" title="L3 Disclosure" closeDialog={closeDisclosureDialogCallBack}  hideCloseButton={true}>
                                <L3DisclosureComponent
                                    closeButtonText={tLang("dashboard.creditScore.l3DisclosureComp.closeButton")}
                                    onCloseCallback={closeDisclosureDialogCallBack}
                                    openAsDialog={true}
                                    submitButtonText={tLang("dashboard.creditScore.l3DisclosureComp.submitButton")}
                                    onSubmitCallback={disclosureSubmitCallBack}
                                    providerName={"transunion"}
                                    isTuCanadianUser={isCanadianUser}
                                ></L3DisclosureComponent>
                            </DialogComponent>
                        )}

                        {showFullSSNDialog && (
                            <DialogComponent dialogId="dialog-full-ssn" title="Full SSN" closeDialog={closeFullSSNDialogComponent} hideCloseButton={true}>
                                {isCanadianUser
                                    ?
                                    <FullSINComponent
                                        closeButtonText={tLang("dashboard.creditScore.fullSINComp.cancelButtonText")}
                                        onCloseCallback={closeFullSSNDialogComponent}
                                        openAsDialog={true}
                                        submitButtonText={tLang("dashboard.creditScore.fullSINComp.submitButtonText")}
                                        onSubmitCallback={submitFullSSNDialogComponent}
                                        displaySSNInputNumber={false}
                                        dobRequired={isDobRequired}
                                        csidUserStatus={props.initCSIDUserStatus}
                                        dispalyAdditionalHeaderMessage={false}
                                        ignoreCSIDSubmission={true}
                                    />
                                    :
                                    <FullSSNComponent
                                        closeButtonText={"Cancel"}
                                        onCloseCallback={closeFullSSNDialogComponent}
                                        openAsDialog={true}
                                        submitButtonText={"Submit"}
                                        onSubmitCallback={submitFullSSNDialogComponent}
                                        displaySSNInputNumber={false}
                                        dobRequired={isDobRequired}
                                        addressRequired={isAddressRequired}
                                        csidUserStatus={props.initCSIDUserStatus}
                                        dispalyAdditionalHeaderMessage={false}
                                        ignoreCSIDSubmission={true}
                                    />
                                }
                            </DialogComponent>
                        )}

                        {showL3OTPOptionDialog && (
                            <DialogComponent dialogId="dialog-tu-otp-options" title="Verify Your Identity" closeDialog={closeL3OTPOptionDialogComponent}>
                                <L3OTPOptionComponent
                                    closeButtonText={"Cancel"}
                                    onCloseCallback={closeL3OTPOptionDialogComponent}
                                    openAsDialog={true}
                                    submitButtonText={"Submit"}
                                    onSubmitCallback={submitL3OTPOptionDialogComponent}
                                    errorCallback={getL3OTPOptionErrorCallBack}
                                    telephone={getPrimatyPhoneNumber()}
                                    ssn={ssn}
                                    dob={dob}
                                    address={address}
                                    postponeActivation={false}
                                    tuTrustedSessionId={tuTrustedSessionId}
                                    maxTUOTPAllowed={maxTUOTPRetryAllowed}
                                    loadedResponse={loadedSecurityQuestionResponse}
                                ></L3OTPOptionComponent>
                            </DialogComponent>
                        )}
                        {showL3OTPVerificationDialog && (
                            <DialogComponent dialogId="dialog-tu-otp-verifications" title="Verify Your Identity" closeDialog={closeL3OTPVerificationComponent}>
                                <L3OTPVerificationComponent
                                    closeButtonText={"Cancel"}
                                    onCloseCallback={closeL3OTPVerificationComponent}
                                    openAsDialog={true}
                                    submitButtonText={"Submit"}
                                    onSubmitCallback={submitL3OTPVerificationComponent}
                                    errorCallback={getL3OTPVerificationErrorCallBack}
                                    telephone={getPrimatyPhoneNumber()}
                                    ssn={ssn}
                                    dob={dob}
                                    address={address}
                                    postponeActivation={false}
                                    tuTrustedSessionId={tuTrustedSessionId}
                                    questionOption={questionOption}
                                    maxTryCount={maxTUOTPRetryAllowed}
                                    selectedOTPOptionText={selectedOTPOptionText}
                                ></L3OTPVerificationComponent>
                            </DialogComponent>
                        )}
                        {showL3SecurityQuestionDialog && (
                            <DialogComponent dialogId="dialog-l3-question" title="L3 Question" closeDialog={closeL3SecurityQuestionDialogComponent}  hideCloseButton={true}>
                                <L3SecurityQuestionComponent
                                    closeButtonText={tLang("dashboard.creditScore.l3SecurityQuestionComp.cancelButtonText")}
                                    onCloseCallback={closeL3SecurityQuestionDialogComponent}
                                    openAsDialog={true}
                                    submitButtonText={tLang("dashboard.creditScore.l3SecurityQuestionComp.submitButtonText")}
                                    onSubmitCallback={submitL3SecurityQuestionDialogComponent}
                                    errorCallback={getL3QuestionErrorCallBack}
                                    ssn={ssn}
                                    dob={dob}
                                    address={address}
                                    postponeActivation={false}
                                    prepareForIDFL3={true}
                                    displayTimerForTimeout={true}
                                    timesInSecondBeforeTimeout={120}
                                    onTimeoutCallback={l3SecurityQuestionDialogTimeOut}
                                    currentTryCount={l3SecurityQuestionTryCount}
                                    maxTryCount={2}
                                    loadedResponse={loadedSecurityQuestionResponse}
                                    tuTrustedSessionId={tuTrustedSessionId}
                                ></L3SecurityQuestionComponent>
                            </DialogComponent>
                        )}

                        {showL3ContinueDialogForError && (
                            <DialogComponent dialogId="dialog-l3-continue-with-error" title="L3 Continue with error" hideCloseButton={true}>
                                <L3ContinueComponent
                                    submitButtonText={"Try verification again"}
                                    onSubmitCallback={l3ContinueWithErrorSubmitCallBack}
                                    messageKey={messageKeyForL3ContinueWithError}
                                    continueFlowWithL3={true}
                                ></L3ContinueComponent>
                            </DialogComponent>
                        )}

                        {showL3InvalidSsnComponent && (
                            <DialogComponent dialogId="dialog-l3-invalid-ssn-component" title="L3 Invalid SSN" hideCloseButton={true}>
                                <L3InvalidSsnComponent
                                    closeButtonText={tLang("dashboard.creditScore.l3InvalidSSNComp.closeButtonText")}
                                    onCloseButtonCallBack={l3InvalidSsnCloseCallBack}
                                    retryButtonText={tLang("dashboard.creditScore.l3InvalidSSNComp.tryAgainButtonText")}
                                    onRetryCallBack={l3InvalidSsnRetryCallBack}
                                    invalidSsnAttemptstatus={invalidSsnAttemptStatus}
                                ></L3InvalidSsnComponent>
                            </DialogComponent>
                        )}

                        {showL3NotEnoughInfoComponent && (
                            <DialogComponent dialogId="dialog-l3-not-enough-info-component" title="L3 Not Enough Information" hideCloseButton={true}>
                                <L3NotEnoughInfoComponent
                                    closeButtonText={tLang("dashboard.creditScore.L3NotEnoughInfoComp.closeButtonText")}
                                    onCloseButtonCallBack={l3NotEnoughInfoCloseCallBack}
                                    retryButtonText={tLang("dashboard.creditScore.L3NotEnoughInfoComp.tryAgainBtnText")}
                                    onRetryCallBack={l3NotEnoughInfoRetryCallBack}
                                    attemptStatus={noQuestionAttemptStatus}
                                ></L3NotEnoughInfoComponent>
                            </DialogComponent>
                        )}

                        {showL3SystemError && (
                            <DialogComponent dialogId="dialog-l3-system-error" title="L3 System Error" hideCloseButton={true}>
                                <L3SystemErrorComponent
                                    refreshButtonText={tLang("dashboard.creditScore.l3SystemErrorComp.refreshButtonText")}
                                    onRefreshCallBack={l3SystemErrorRefreshCallBack}
                                    closeButtonText={tLang("dashboard.creditScore.l3SystemErrorComp.closeButtonText")}
                                    onCloseButtonCallBack={l3SystemErrorCloseCallBack}
                                ></L3SystemErrorComponent>
                            </DialogComponent>
                        )}

                        {showL3VerifiedDialog && (
                            <DialogComponent dialogId="dialog-l3-complete-with-success" title="L3 complete" hideCloseButton={true}>
                                <L3SuccessComponent
                                    openAsDialog={false}
                                    continueButtonText={tLang("dashboard.creditScore.l3SuccessComp.continueButtonText")}
                                    onContinueCallback={l3SuccessComponentContinueCallBack}
                                ></L3SuccessComponent>
                            </DialogComponent>
                        )}
                    </React.Fragment>
                )
            }
        </div>
    );
};
export default IDFCreditAuthentication;
